import Session from "./session";

class OrderHistory  {
	constructor(request) {
		this.request = request
		this.endpoint = 'orderhistory'
	}

	async UserItems(cartid, username, isexistingdata) {
		let jwtToken = await Session.GetJWTToken();
		const body = {
			username:username,
			isexistingdata:isexistingdata
		}
		return this.request.send(
			`${this.endpoint}/${cartid}/useritems`,
			'POST',
			body,
			jwtToken
		)
	}

	async GetCartHistory(username, type="order", statusFilter="", pageOffset=0) {
		let jwtToken = await Session.GetJWTToken();
		const body = {
			username:username,
			statusfilter:statusFilter,
			pageoffset:pageOffset,
			type:type
		};
		return this.request.send(
			`${this.endpoint}/list`,
			'POST',
			body,
			jwtToken
		)
	}

}

export default OrderHistory
